import React from 'react'
import {
    Badge,
    Box,
    Button,
    Flex,
    Icon,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text
} from '@chakra-ui/react'
import { MdOutlineImage } from 'react-icons/md'
import ThemePresetPicker from 'components/fields/ThemePresetPicker'

const WhatsNewModal = ({ announcement, isOpen, onClose, onPrimaryAction }) => {
    if (!announcement) {
        return null
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
            <ModalOverlay bg="blackAlpha.600" />
            <ModalContent borderRadius="2xl" overflow="hidden">
                <ModalHeader pt={8} px={8} pb={2}>
                    <Badge colorScheme="blue" borderRadius="full" px={3} py={1} mb={3}>
                        {announcement.eyebrow || announcement.title}
                    </Badge>
                    <Text fontSize={{ base: '2xl', md: '3xl' }} fontWeight="700" color="gray.800" lineHeight="short">
                        {announcement.featureTitle}
                    </Text>
                </ModalHeader>
                <ModalCloseButton top={4} right={4} />

                <ModalBody px={8} pb={6}>
                    <Text color="gray.600" fontSize="md" mb={6}>
                        {announcement.description}
                    </Text>

                    <Box
                        borderWidth="1px"
                        borderStyle="dashed"
                        borderColor="gray.200"
                        borderRadius="xl"
                        bg="gray.50"
                        minH={{ base: '180px', md: '260px' }}
                        overflow="hidden"
                    >
                        {announcement.imageSrc ? (
                            <Image
                                src={announcement.imageSrc}
                                alt={announcement.imageAlt || announcement.featureTitle}
                                objectFit="cover"
                                w="100%"
                                h="100%"
                            />
                        ) : announcement.previewPresets?.length ? (
                            <Box p={{ base: 4, md: 5 }}>
                                <Text fontSize="sm" color="gray.500" mb={4}>
                                    A quick look at the new theme styles available on the form page.
                                </Text>
                                <Box pointerEvents="none">
                                    <ThemePresetPicker
                                        presets={announcement.previewPresets}
                                        value={announcement.previewPresets[0].value}
                                        onChange={() => {}}
                                        columns={{ base: 1, md: 2 }}
                                    />
                                </Box>
                            </Box>
                        ) : (
                            <Flex
                                direction="column"
                                align="center"
                                justify="center"
                                color="gray.500"
                                h="100%"
                                minH={{ base: '180px', md: '260px' }}
                                px={6}
                                textAlign="center"
                            >
                                <Icon as={MdOutlineImage} boxSize={10} mb={3} color="gray.400" />
                                <Text fontWeight="600">{announcement.imagePlaceholderLabel || 'Feature screenshot'}</Text>
                                <Text fontSize="sm" color="gray.500" mt={1}>
                                    Add an image later without changing the modal structure.
                                </Text>
                            </Flex>
                        )}
                    </Box>
                </ModalBody>

                <ModalFooter px={8} pb={8} pt={0}>
                    <Button colorScheme="blue" onClick={onPrimaryAction}>
                        {announcement.ctaLabel || 'Explore'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default WhatsNewModal
